import { render, staticRenderFns } from "./AdminPlayers.vue?vue&type=template&id=519ea6e1&scoped=true&"
import script from "./AdminPlayers.vue?vue&type=script&lang=js&"
export * from "./AdminPlayers.vue?vue&type=script&lang=js&"
import style0 from "./AdminPlayers.vue?vue&type=style&index=0&id=519ea6e1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519ea6e1",
  null
  
)

export default component.exports